import React, { Fragment } from "react";
import { Field, FieldProps, Form, FormikProps } from "formik";
import classnames from "classnames";
import { WithTranslation, withTranslation } from "react-i18next";

import { AddUserFormValues } from "./AddUser";

import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

import IconClose from "@material-ui/icons/Close";

import Stepper from "components/common/stepper/Stepper";

const AddUser = ({
  formikProps,
  formikProps: { errors, touched, isSubmitting },
  close,
  t
}: {
  formikProps: FormikProps<AddUserFormValues>;
  close: (event: any) => void;
} & WithTranslation) => (
  <Form className="d-flex flex-column h-100">
    <div className="d-flex flex-column h-100">
      <div
        className="d-flex py-2 px-3 justify-content-between align-items-center"
        style={{ borderBottom: "1px solid #dadce0" }}
      >
        <IconButton onClick={close}>
          <IconClose fontSize="small" />
        </IconButton>
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          size="small"
          className="p-2"
          disabled={!formikProps.isValid || isSubmitting}
        >
          {t("application.addUser.createButton")}
        </Button>
      </div>
      <div
        className="flex-grow-1 py-4 px-5 overflow-auto"
        style={{ backgroundColor: "rgb(241, 243, 244)" }}
      >
        <Stepper
          titles={t("application.addUser.stepper.titles", {
            returnObjects: true
          })}
          steps={[
            <Fragment>
              <section className="box rounded p-3 mb-2">
                <p className="box__description mb-1">
                  {t("application.addUser.fields.email.label")}{" "}
                  <small>
                    ({t("application.addUser.fields.email.description")})
                  </small>
                </p>
                <section className="d-flex flex-column">
                  <Field
                    name="email"
                    render={({ field }: FieldProps<AddUserFormValues>) => (
                      <TextField
                        {...field}
                        autoFocus
                        inputProps={{
                          className: "px-2"
                        }}
                        className={classnames("bg-white m-0", {
                          "is-valid": !errors.email && touched.email,
                          "is-invalid": errors.email && touched.email
                        })}
                        tabIndex={1}
                      />
                    )}
                  />
                  {errors.email && touched.email && (
                    <div className="d-flex invalid-feedback">
                      {t("application.addUser.fields.email.error")}
                    </div>
                  )}
                </section>
              </section>
              <section className="box rounded p-3 mb-2">
                <p className="box__description mb-1">
                  {t("application.addUser.fields.forename.label")}{" "}
                  <small>
                    ({t("application.addUser.fields.forename.description")})
                  </small>
                </p>
                <section className="d-flex flex-column">
                  <Field
                    name="forename"
                    render={({ field }: FieldProps<AddUserFormValues>) => (
                      <TextField
                        {...field}
                        inputProps={{
                          className: "px-2"
                        }}
                        className={classnames("bg-white m-0", {
                          "is-valid": !errors.forename && touched.forename,
                          "is-invalid": errors.forename && touched.forename
                        })}
                        tabIndex={2}
                      />
                    )}
                  />
                  {errors.forename && touched.forename && (
                    <div className="d-flex invalid-feedback">
                      {t("application.addUser.fields.forename.error")}
                    </div>
                  )}
                </section>
              </section>
              <section className="box rounded p-3 mb-2">
                <p className="box__description mb-1">
                  {t("application.addUser.fields.surname.label")}{" "}
                  <small>
                    ({t("application.addUser.fields.surname.description")})
                  </small>
                </p>
                <section className="d-flex flex-column">
                  <Field
                    name="surname"
                    render={({ field }: FieldProps<AddUserFormValues>) => (
                      <TextField
                        {...field}
                        inputProps={{
                          className: "px-2"
                        }}
                        className={classnames("bg-white m-0", {
                          "is-valid": !errors.surname && touched.surname,
                          "is-invalid": errors.surname && touched.surname
                        })}
                        tabIndex={3}
                      />
                    )}
                  />
                  {errors.surname && touched.surname && (
                    <div className="d-flex invalid-feedback">
                      {t("application.addUser.fields.surname.error")}
                    </div>
                  )}
                </section>
              </section>
            </Fragment>
          ]}
        />
      </div>
    </div>
  </Form>
);

export default withTranslation()(AddUser);
